<template>
  <div class="settings-softphone">
    <div class="clearly-anywhere ma-2">
      <clearly-anywhere />
    </div>
    <div class="clearly-anywhere-creds ma-2">
      <creds :qrlink="qrlink" @reset="getQRCode()" />
    </div>
  </div>
</template>

<script>
import ClearlyAnywhere from '@/components/settings/clearly_anywhere'
import Creds from '@/components/settings/clearly_anywhere/creds'
import events from 'Store/events'
import API from '@/api'

export default {
  name: 'settings-softphone',
  components: {
    ClearlyAnywhere,
    Creds
  },
  data () {
    return {
      qrcodeDialog: false,
      qrlink: null
    }
  },
  mounted () {
    events.$on('clearly-anywhere', this.getQRCode())
  },
  methods: {
    openLink: function (url) {
      window.open(url, '_blank')
    },
    getQRCode: function () {
      events.mask()
      this.qrcodeDialog = true
      this.qrlink = null
      API.getClearlyAnywhereAcc().then(({ data: resp }) => {
        if (!resp.success) {
          throw new Error(`API response success is false. ${resp.data}`)
        }
        this.qrlink = resp.data
      }).catch(err => {
        this.dbg('Failed to get Cleary Anywhere data')
        this.dbg(err)
        const emsg = err.response?.data?.exception ||
          this.$t('settings.clearlyaw.failed')
        events.pubError(emsg)
      }).finally(() => {
        events.unmask()
      })
    }
  }
}
</script>

<style></style>
